// extracted by mini-css-extract-plugin
export default {"Subpage":"general_Subpage__Rcs4c","TopFivePatternsContainer":"general_TopFivePatternsContainer__YsTTL"};